// actions.js
import { POST_DATA_REQUEST, POST_DATA_SUCCESS, POST_DATA_FAILURE, POST_DATA_RESET } from '../../../Constants/actionTypes';
import Swal from 'sweetalert2';

import {
    API_INGEST_SIH_NARRATIVE,
    API_INGEST_SERVICE_PREDICTION,
    API_INGEST_CHANGE_MANAGEMENT,
    API_INGEST_CXO_DASHBOARD,
    API_INGEST_END_TO_END,
    API_INGEST_POLICY_BASED_CLUSTER,
    API_INGEST_SECOPS,
    API_INGEST_ONE_BMC,

    API_INGEST_CSM_POST_CSM_MS,
    API_INGEST_CSM_POST_CSM_IB,
    API_INGEST_CSM_POST_CSM_AW,

    API_INGEST_BYO_BHOM,
    API_INGEST_BYO_ITSM,

    API_INGEST_SERVICE_OPS_MS_FULL,
    API_INGEST_SERVICE_OPS_MS_ITSM,
    API_INGEST_SERVICE_OPS_MS_BHOM,
    API_INGEST_SERVICE_OPS_IB_FULL,
    API_INGEST_SERVICE_OPS_IB_ITSM,
    API_INGEST_SERVICE_OPS_IB_BHOM,


    API_INGEST_OBSERVABILTY_MS,
    API_INGEST_OBSERVABILTY_IB,
    API_INGEST_OBSERVABILTY_AISM_MS,
    API_INGEST_OBSERVABILTY_AISM_IB,


    API_INGEST_BANKING_NETWORK_OUTAGE,
    API_INGEST_BANKING_UNAUTHEIRZED_CHNAGE,

    API_INGEST_HRSM,
    API_INGEST_VULOPS,
    API_INGEST_ONE_MODEL_ALL_INDUSTRIES_RENAME

} from '../../../Constants/apiUrls';

// Helper function to handle errors
const handleErrors = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        try {
            const errorJson = JSON.parse(errorText);
            return errorJson.error || 'Unknown Error'; // Return the error message
        } catch (e) {
            return errorText || 'Unknown Error'; // Return the error text if JSON parsing fails
        }
    }
    return null; // No error
};



const pickTenant = (t = {}) => ({
    bhomUrl: t.tenantUrl || t['BHOM URL'] || '',
    itsmUrl: t.itsmUrl || t['ITSM URL'] || '',
    key: t.key || t['API Key'] || '',
    secretKey: t.secretKey || t['Secret Key'] || '',
    username: t.username || t['Username'] || '',
    password: t.password || t['Password'] || '',
    type: t.type || '',
});


export const resetOnSuccessIngest = () => ({
    type: POST_DATA_RESET
});



const getApiUrl = (useCase) => {
    console.log(useCase)
    switch (useCase) {
        case 'Security Incident Handling':
            return API_INGEST_SIH_NARRATIVE;
        case 'Service Predictions':
            return API_INGEST_SERVICE_PREDICTION;
        case 'Change Management DevOps meets ITIL':
            return API_INGEST_CHANGE_MANAGEMENT;
        case "BMC Helix Platform Demo for Executives (CXO Dashboard Narrative)":
            return API_INGEST_CXO_DASHBOARD;
        case 'End-to-End Observability Narrative with Live App':
            return API_INGEST_END_TO_END;
        case 'Policy Based Clustering (Network Alerts)':
            return API_INGEST_POLICY_BASED_CLUSTER;
        case 'SecOps-AIOps':
            return API_INGEST_SECOPS;
        case 'One BMC Narrative - Mainframe & Distributed':
            return API_INGEST_ONE_BMC

        // CSM
        case 'CSM Narrative (Media Service)':
            return API_INGEST_CSM_POST_CSM_MS;
        case 'CSM Narrative (Insta Banking)':
            return API_INGEST_CSM_POST_CSM_IB;
        case 'CSM Narrative (Apex-Watches)':
            return API_INGEST_CSM_POST_CSM_AW;

        // Service Ops Media Service
        case 'ServiceOps-MS-Full':
            return API_INGEST_SERVICE_OPS_MS_FULL;
        case 'ServiceOps-MS-BHOM':
            return API_INGEST_SERVICE_OPS_MS_BHOM;
        case 'ServiceOps-MS-ITSM':
            return API_INGEST_SERVICE_OPS_MS_ITSM;
        case 'ServiceOps-IB-Full':
            return API_INGEST_SERVICE_OPS_IB_FULL;
        case 'ServiceOps-IB-BHOM':
            return API_INGEST_SERVICE_OPS_IB_BHOM;
        case 'ServiceOps-IB-ITSM':
            return API_INGEST_SERVICE_OPS_IB_ITSM;

        // Observbilty
        case 'Media-service-Observabilty-Service-Ops':
            return API_INGEST_OBSERVABILTY_AISM_MS;
        case 'Media-Service-Observabilty':
            return API_INGEST_OBSERVABILTY_MS;
        case 'Insta-Banking-Observabilty-Service-Ops':
            return API_INGEST_OBSERVABILTY_AISM_IB;
        case 'Insta-Banking-Observabilty':
            return API_INGEST_OBSERVABILTY_IB;

        // Banking
        case 'The Complete Banking Story Network Traffic Burst Impacting Applications':
            return API_INGEST_BANKING_NETWORK_OUTAGE;
        case 'The Complete Banking Story Application Unauthorized Change':
            return API_INGEST_BANKING_UNAUTHEIRZED_CHNAGE;



        // HRSM
        case 'Agentic AI Driven HRSM':
            return API_INGEST_HRSM;


        // VulNops
        case 'HelixGPT - Vulnerability Resolver':
            return API_INGEST_VULOPS

        // One Model, All Industries (Rename)    
        case 'One Model, All Industries (Rename)':
            return API_INGEST_ONE_MODEL_ALL_INDUSTRIES_RENAME;



        default:
            throw new Error('Invalid use case');
    }
};


export const postData = (tenantDetails, useCase, title) => async (dispatch, getState) => {



    dispatch({ type: POST_DATA_REQUEST });

    try {
        // Retrieve access token from the state
        const state = getState();
        const accessToken = state.auth.accessToken;

        const apiUrl = getApiUrl(useCase);

        console.log(apiUrl)

        const t = pickTenant(tenantDetails);

        const body = {
            bhomUrl: t.bhomUrl,
            itsmUrl: t.itsmUrl,
            key: t.key,
            secretKey: t.secretKey,
            username: t.username,
            password: t.password,
            title: title,
        };

        console.log("Body" + body)

        // Add 'usecase' to the body if the use case is SERVICE_PREDICTION
        if (useCase === 'Service Predictions') {
            body.useCase = "Apex-Fitness";
            body.apiKey = t.key;
        }

        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(body),
        });
        const errorMessage = await handleErrors(response);
        console.log("First Error" + errorMessage)
        if (errorMessage) {
            throw new Error(errorMessage);

        }
        const result = await response.json();
        console.log("Result" + result)
        dispatch({ type: POST_DATA_SUCCESS, payload: result });
    } catch (error) {
        console.log("Catch Error" + error)
        let errorMessage;
        if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
            errorMessage = 'Server is currently down. Please try again later.';
        } else {
            errorMessage = error.message;
        }
        dispatch({ type: POST_DATA_FAILURE, payload: errorMessage });
    }
};


export const postBYO = (tenantDetails, file, useCase, title) => async (dispatch, getState) => {
    dispatch({ type: POST_DATA_REQUEST });
    try {
        const state = getState();
        const accessToken = state.auth.accessToken;

        var apiurl = null;
        if (useCase === "Build Your Own (BHOM)") {
            apiurl = API_INGEST_BYO_BHOM
        } else if (useCase === "Build Your Own (ITSM)") {
            apiurl = API_INGEST_BYO_ITSM
        }

        const convertBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = () => {
                    resolve(fileReader.result);
                };
                fileReader.onerror = (error) => {
                    reject(error);
                };
            });
        };
        file = await convertBase64(file);

        const t = pickTenant(tenantDetails);

        const body = {
            file,
            bhomUrl: t.bhomUrl,
            itsmUrl: t.itsmUrl,
            key: t.key,
            secretKey: t.secretKey,
            username: t.username, 
            password: t.password,
            title,
        };

        const response = await fetch(apiurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(body),
        });
        const errorMessage = await handleErrors(response);
        if (errorMessage) {
            throw new Error(errorMessage);
        }
        const result = await response.json();
        dispatch({ type: POST_DATA_SUCCESS, payload: result });
    } catch (error) {
        let errorMessage;
        if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
            errorMessage = 'Server is currently down. Please try again later.';
        } else {
            errorMessage = error.message;
        }
        dispatch({ type: POST_DATA_FAILURE, payload: errorMessage });
    }


}


// Rename
export const postRenameService = (tenantDetails, useCase, title) => async (dispatch, getState) => {

    // console.log("useCase" + useCase)
    // console.log("title" + title)
    dispatch({ type: POST_DATA_REQUEST });

    try {
        const state = getState();
        const accessToken = state.auth.accessToken;

        const apiUrl = getApiUrl(title);

        
        const t = pickTenant(tenantDetails);

        const body = {
            bhomUrl: t.bhomUrl,
            itsmUrl: t.itsmUrl,
            key: t.key,
            secretKey: t.secretKey,
            username: t.username,
            password: t.password,
            title: useCase, // you already want title to be the selected service name
        };

        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(body),
        });

        const errorMessage = await handleErrors(response);
        if (errorMessage) throw new Error(errorMessage);

        const result = await response.json();
        dispatch({ type: POST_DATA_SUCCESS, payload: result });

    } catch (error) {
        const errorMessage = error.message.includes('NetworkError') || error.message === 'Failed to fetch'
            ? 'Server is currently down. Please try again later.'
            : error.message;

        dispatch({ type: POST_DATA_FAILURE, payload: errorMessage });
    }
};

